import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-dialog-one-button',
    template: require('./oneButtonDialog.html')
})
export class OneButtonDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<OneButtonDialogComponent>) public dialogRef: MatDialogRef<OneButtonDialogComponent>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}
